module.exports = __webpack_public_path__ + "img/Reproducir_sonido_Pequeño.e4a83c62.svg";